import React from 'react';
import { Modal, Select } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const OtherAvailableCurrencyModal = ({
  visible,
  onConfirm,
  onCancel,
  currencyOptions,
}: {
  visible: boolean;
  onConfirm: any;
  onCancel: () => void;
  currencyOptions: {
    label: string;
    value: string;
  }[];
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  // const [confirmDisable, setConfirmDisable] = React.useState<boolean>(false);
  const [selectedCurrency, setSelectedCurrency] = React.useState<{
    key: string;
    label: string;
    value: string;
  } | null>(null);

  const onOk = () => {
    onConfirm(selectedCurrency);
    setSelectedCurrency(null);
  };
  const onCancelModal = () => {
    setSelectedCurrency(null);
    onCancel();
  };

  return (
    <Modal
      forceRender={true}
      title={getI18n('salesChannelCurrency.index.addOtherAvailableCurrency')}
      visible={visible}
      okText={getI18n('general.confirm')}
      cancelText={getI18n('general.cancel')}
      maskClosable={false}
      onOk={onOk}
      onCancel={onCancelModal}>
      <div style={{ marginBottom: 4, fontWeight: 500 }}>
        {getI18n('salesChannelCurrency.index.availableCurrency')}*
      </div>
      <Select
        labelInValue
        value={selectedCurrency ?? undefined}
        onChange={(v) => {
          setSelectedCurrency(v);
        }}
        placeholder='Select...'
        style={{ width: 480 }}
        size='large'
        options={currencyOptions.map((o) => ({
          label: o.label,
          value: o.value,
        }))}
      />
    </Modal>
  );
};

export default OtherAvailableCurrencyModal;
